
<div id="accountExistModal" class="form-step-modal modal fade" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content form-step-modal__content">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      <div class="modal-body form-step-modal__body">
        Cet email existe déja,veuillez vous connecter
      </div>
    </div>
  </div>
</div>

<div class="row d-flex justify-content-center">
  <div class="col-md-12">
    <form (ngSubmit)="onSubmit()" #preAccount="ngForm">
      <div class="form-group row has-danger" *ngIf="errorMsg">
        <div class="col-12">
          <div class="form-control-feedback"><i class="fa fa-exclamation-circle" aria-hidden="true"></i> {{ errorMsg }}</div>
        </div>
      </div>
      <!-- firstname/lastname field -->
      <div class="form-group row" [ngClass]="{'has-danger': firstname.errors && (firstname.dirty || firstname.touched || errorMsg) || lastname.errors && (lastname.dirty || lastname.touched || errorMsg)}">
        <div class="col-lg-6 col-xs-12 rp-xs">
          <div class="input-group mb-2 mr-sm-2 mb-sm-0">
            <input class="form-control" type="text" id="firstname" name="firstname" placeholder="{{'shared_sign_up_form.lastname'| translate}}" [(ngModel)]="account.firstname" #firstname="ngModel" required>
          </div>
          <div class="form-control-feedback alert alert-danger custom-alert-danger" *ngIf="account.firstname.length == 0">{{'shared_sign_up_form.your_lastname_is_required'| translate}}</div>
        </div>
        <div class="col-lg-6 col-xs-12 rp-xs">
          <div class="input-group mb-2 mr-sm-2 mb-sm-0">
            <input class="form-control" type="text" id="lastname" name="lastname" placeholder="{{'shared_sign_up_form.firstname'| translate}}" [(ngModel)]="account.lastname" #lastname="ngModel" required>
          </div>
          <div class="form-control-feedback alert alert-danger custom-alert-danger" *ngIf="account.lastname.length == 0"> {{'shared_sign_up_form.your_firstname_is_required'| translate}}</div>
        </div>
      </div>
      <!-- email field -->
      <div class="form-group row" [ngClass]="{'has-danger': email.errors && (email.dirty || email.touched || errorMsg)}">
        <div class="col-12 rp-xs">
          <div class="input-group mb-2 mr-sm-2 mb-sm-0">
            <input class="form-control" type="email" value="" id="email" name="email" placeholder="{{'front_booking_infos.mail_adress'| translate}}" [(ngModel)]="account.email" #email="ngModel" required email>
          </div>
          <div class="form-control-feedback alert alert-danger custom-alert-danger" *ngIf="account.email.length<=0"> {{'shared_sign_up_form.your_mail_adress_is_required'| translate}}</div>
          <div class="form-control-feedback alert alert-danger custom-alert-danger" *ngIf="account.email.length>0 ">{{'shared_sign_up_form.your_mail_adress_is_invalid'| translate}}</div>
        </div>
      </div>
      <!-- password field -->
      <div class="form-group row" [ngClass]="{'has-danger':  (emailConfirm.touched && !emailConfirm.valid) || errorMsg }">
        <div class="col-12 rp-xs">
          <div class="input-group mb-2 mr-sm-2 mb-sm-0">
            <input class="form-control" oncopy="return false" onpaste="return false" type="email" value="" id="emailConfirm" name="emailConfirm" placeholder="{{'front_booking_infos.rewrite_mail_adress'| translate}}" [(ngModel)]="account.emailConfirm"  #emailConfirm="ngModel"  required>
          </div>
          <div class="form-control-feedback alert alert-danger custom-alert-danger" *ngIf="account.emailConfirm.length<=0">Confirmation d'adresse email requise</div>
          <div class="form-control-feedback alert alert-danger custom-alert-danger" *ngIf="account.emailConfirm.length>0 ">Confirmation d'adresse email invalide</div>
          <div class="alert-danger custom-alert-danger" *ngIf="account.emailConfirm != account.email && account.emailConfirm.length >0 && account.email.length >0">Les emails doivent être identiques.</div>
        </div>
      </div>
      <!-- submit button -->
      <div class="form-group row ">
        <div class="offset-sm-1 rp-xs col-sm-10 text-center">
          <button type="submit" class="btn btn-primary btn-lg " [disabled]="!preAccount.form.valid">{{'shared_sign_up_form.pursu'| translate}}</button>
        </div>
      </div>
    </form>
  </div>
</div>


